import { camelizeKeys } from 'humps';
import { formatAsUriParameters, get } from '@namespace/helpers';

export const getBsActiveWithdrawBonuses = (params = {}) => {
  const queryParams = formatAsUriParameters(params);
  return get(
    `/service/prewager/bonus-system/v1/campaigns/withdraw-cancel${
      queryParams ? `?${queryParams}` : ''
    }`
  )
    .then(camelizeKeys)
    .then(({ status, data }) => (status === 'success' ? data : {}));
};
